export default __webpack_public_path__ + "static/CRAFd-DPPA-UNCCD-logo-56ab0af6c6cdbc13abbab3fd658792d1.svg";